import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import {
  sendRequest,
  selectData
} from 'mt-react-common/common/reducers/data/reducer';

const meStatRN = 'messengerModule.objects.meStat';

class NewMessages extends Component {
  constructor(props) {
    super(props);
    this.props.sendRequest();
  }
  render() {
    let badgeCountNotReadNoticesNotices;
    if (this.props.data.countNewMessages > 0) {
      badgeCountNotReadNoticesNotices = (
        <span className="badge badge-xs badge-circle badge-info badge-counter">
          {this.props.data.countNewMessages}
        </span>
      );
    }

    return (
      <li className={`dropdown`}>
        <Link to="/main/messenger/rooms">
          {badgeCountNotReadNoticesNotices}
          <i className="fa fa-comments-o fa-lg" />
        </Link>
      </li>
    );
  }
}

NewMessages.propTypes = {
  // CONNECT STATES
  sendRequest: PropTypes.func.isRequired,
  data: PropTypes.shape({
    countNewMessages: PropTypes.string
  }).isRequired
};

const mapStateToProps = state => ({
  data: selectData(state, meStatRN)
});

const mapDispatchToProps = dispatch => ({
  sendRequest: () => dispatch(sendRequest(meStatRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewMessages);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Header/NewMessages/NewMessages.js